exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .hrVertical{\r\n    border-right: 0.05rem solid;\r\n    height: 3.5rem;\r\n    display: block;\r\n} */\r\n\r\n\r\n.hrVertical {\r\n    border-right: 0.1rem solid !important;\r\n    /* height: 3.5rem !important; */\r\n    display: inline-block !important;\r\n    -webkit-transition: auto !important;\r\n    transition: auto !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/main-page/main-page.component.css
// module id = ../../../../../src/app/main-page/main-page.component.css
// module chunks = main